import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import { Button } from '@salesforce/design-system-react';

import { ProfileMetadataRow } from '../';

import './ProfileMetadataEditor.scss';

class ProfileMetadataEditor extends Component {
  addTag() {
    this.props.actions.updateProfileTag({ tagType: '', tagValue: '' });
  }

  deleteTag(id) {
    this.props.actions.deleteProfileTag({ id });
  }

  rows() {
    const profile = this.props.profile;

    if (profile.tags && profile.tags.length) {
      return profile.tags.map((obj, index) => {
        return (
          <ProfileMetadataRow
            id={`tag${index}`}
            key={`tag${index}`}
            {...obj}
            onDelete={this.deleteTag.bind(this)}
            actions={this.props.actions}
          />
        );
      });
    }
  }

  render() {
    return (
      <div className="profile-metadata-editor">
        {this.rows()}
        <Button
          className="profile-add-tag-button"
          label="Add Tag"
          iconCategory="utility"
          iconName="add"
          iconPosition="left"
          onClick={this.addTag.bind(this)}
        />
      </div>
    );
  }
}

ProfileMetadataEditor.propTypes = {
  profile: PropTypes.object,
  actions: PropTypes.object,
  location: PropTypes.object
};

export default injectIntl(ProfileMetadataEditor);
